import { useNavigate } from 'react-router-dom';
import { useT } from '../i18n/LangContext';
import LangToggle from './LangToggle';

/**
 * Shared top nav for all user-facing pages.
 *
 * Props:
 *   activePage  — 'home' | 'crm' | 'meta' | 'editor'   (highlights the active link)
 *   rightSlot   — optional extra JSX rendered before LangToggle (e.g. Copy Link button)
 *   showLinks   — bool, default true  (hide nav links on editor to keep it minimal)
 */
export default function AppNav({ activePage, rightSlot, showLinks = true }) {
  const navigate = useNavigate();
  const { t } = useT();

  const userEmail = localStorage.getItem('userEmail') || '';
  const isAdmin = !!localStorage.getItem('adminToken');

  function logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('userEmail');
    navigate('/auth', { replace: true });
  }

  const links = [
    { key: 'home', label: t('navGenerator'), path: '/', adminOnly: false },
    { key: 'crm',  label: t('navCrm'),       path: '/crm', adminOnly: false },
    { key: 'meta', label: t('navMetaCampaigns'), path: '/meta', adminOnly: true },
  ].filter((l) => !l.adminOnly || isAdmin);

  return (
    <div className="appnav-border">
      <nav className="appnav">
        {/* Logo */}
        <div className="appnav-logo" onClick={() => navigate('/')}>
          FORMLY <span className="appnav-logo-accent">HR</span>
        </div>

        {/* Right side */}
        <div className="appnav-r">
          {/* Page links */}
          {showLinks && (
            <div className="appnav-links">
              {links.map((l) => (
                <button
                  key={l.key}
                  type="button"
                  className={`appnav-link${activePage === l.key ? ' appnav-link-active' : ''}`}
                  onClick={() => navigate(l.path)}
                >
                  {l.label}
                </button>
              ))}
            </div>
          )}

          {/* Extra slot (e.g. Copy Link in editor) */}
          {rightSlot}

          {/* User email pill */}
          {userEmail && (
            <span className="appnav-user-pill" title={userEmail}>
              {userEmail}
            </span>
          )}

          <LangToggle />

          <button type="button" className="appnav-logout-btn" onClick={logout}>
            {t('navLogout')}
          </button>
        </div>
      </nav>
    </div>
  );
}
